// central.eu — shared data for the landing + console views.

export interface IDc {
  id: string;
  code: string;
  city: string;
  country: string;
  lng: number;
  lat: number;
  state: 'live' | 'build';
  tier: string;
}

export const DCS: IDc[] = [
  { id: 'bre1', code: 'BRE1', city: 'Bremen', country: 'DE', lng: 8.8, lat: 53.08, state: 'live', tier: 'Own facility' },
  { id: 'fra1', code: 'FRA1', city: 'Frankfurt', country: 'DE', lng: 8.68, lat: 50.11, state: 'build', tier: '2026 Q4' },
  { id: 'ams1', code: 'AMS1', city: 'Amsterdam', country: 'NL', lng: 4.89, lat: 52.37, state: 'build', tier: '2027 Q1' },
  { id: 'par1', code: 'PAR1', city: 'Paris', country: 'FR', lng: 2.35, lat: 48.85, state: 'build', tier: '2027 Q2' },
  { id: 'sto1', code: 'STO1', city: 'Stockholm', country: 'SE', lng: 18.07, lat: 59.33, state: 'build', tier: '2027' },
  { id: 'waw1', code: 'WAW1', city: 'Warsaw', country: 'PL', lng: 21.01, lat: 52.23, state: 'build', tier: '2027' },
];

export const EU_ISO = [
  'AUT', 'BEL', 'BGR', 'HRV', 'CYP', 'CZE', 'DNK', 'EST', 'FIN', 'FRA', 'DEU', 'GRC',
  'HUN', 'IRL', 'ITA', 'LVA', 'LTU', 'LUX', 'MLT', 'NLD', 'POL', 'PRT', 'ROU', 'SVK',
  'SVN', 'ESP', 'SWE', 'NOR', 'ISL', 'CHE', 'LIE',
];

export const TICKER_ITEMS = [
  'BRE1 · BREMEN, DE — OWN FACILITY',
  'ENCRYPTED MESH · WIREGUARD BETWEEN NODES',
  'INGRESS · EU CLOUD PARTNERS → BRE1',
  'EU CARRIER FIBER · BREMEN UPLINK',
  'DRIVEN BY OPEN SOURCE · COMPUTE.CLOUD · SERVE.ZONE · MODELGRID',
  'CONTAINER WORKLOADS · OCI COMPATIBLE',
  'EPYC 9004 · AMPERE ALTRA · NVMe',
  'GDPR · NIS2 · ISO 27001',
  'RESIDENCY ATTESTED · EU ONLY',
  'FRA1 · AMS1 · IN BUILD',
];

export { CATALOG, DEMAND, REGIONS } from '../ts/quote-catalog.js';
export type { IQuoteRegion as IRegion } from '../ts/quote-catalog.js';

/** Map colors resolved from the current bright/dark theme. */
export function mapColors(goBright: boolean) {
  return {
    paper: goBright ? '#f5f5f7' : '#000000',
    paper2: goBright ? '#ececef' : '#1c1c1e',
    rule: goBright ? 'rgba(0,0,0,.12)' : 'rgba(255,255,255,.16)',
    eu: goBright ? '#0033A0' : '#6a8cff',
    euFill: goBright ? '#e8eaf2' : '#1a1e2e',
  };
}
